<script setup lang="ts">
import { computed } from "vue";
import { UiInfoBox, UiText } from "@shopexperts/shared";
import { atPlanLimitGuidance, overPlanLimitGuidance, type PlanLimitFeature } from "./utils/planLimitGuidance";

const props = defineProps<{
    feature: PlanLimitFeature;
    limit: number | null;
    count: number;
}>();

const isOver = computed(() => props.limit !== null && props.count > props.limit);

const text = computed(() => {
    if (props.limit === null || props.count < props.limit) return null;
    return isOver.value
        ? overPlanLimitGuidance(props.feature, props.limit, props.count - props.limit)
        : atPlanLimitGuidance(props.feature, props.limit);
});
</script>

<template>
    <!-- UiInfoBox reads variant once at setup; the key remounts it on change. -->
    <UiInfoBox v-if="text" :key="isOver ? 'over' : 'at'" :variant="isOver ? 'warning' : 'info'">
        <UiText as="p" variant="p-small" :text="text" />
    </UiInfoBox>
</template>
